import { IgenomicsAction } from '../../core/interfaces/genomics-action.interface';
import { QualityCheckActions } from './quality-check.actions';
import { WorkflowDrivenCacheablesEntity } from '@ispm/workflow/entities/workflow-driven-cacheables.entity';
import { IQualityCheckState } from './quality-check.state';
import { CORE_ACTIONS } from '../../core/constants/core-actions.constant';

export function qualityCheckReducer(state: IQualityCheckState = { }, action: IgenomicsAction<WorkflowDrivenCacheablesEntity>): IQualityCheckState {
  switch (action.type) {
    case CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS:
    case QualityCheckActions.INIT:
      return action.payload.init(state, null, { });
    case QualityCheckActions.SET_RESULTS:
      return action.payload.upsert(state);
    case QualityCheckActions.DELETE_RESULTS:
      return action.payload.remove(state);
    default:
      return state;
  }
}
